export { default } from "./HomeHero"
